export const SET_USER_INFORMATIONS = 'app/WithUserInformations/SET_USER_INFORMATIONS';
export const WITH_USER_INFORMATIONS = 'WithUserInformations';
